// Must be the first import
// eslint-disable-next-line no-undef

import '@pixi/unsafe-eval';
import { render } from 'preact';
import { App } from './App.tsx';
import './App.css';
import './index.scss';
import 'react-responsive-carousel/lib/styles/carousel.min.css';

declare global {
  interface OneTrustType {
    ToggleInfoDisplay: () => void;
  }

  interface Window {
    OneTrust: OneTrustType;
  }
}

render(<App />, document.getElementById('app')!);
